import { tWithKeyAttr as t } from "../../i18nHelper";
import { AppImage } from "../appMedia";
import myTreatmentStyles from "./myTreatment.module.css";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../services/hooks";
import {
  userAllAppointmentProgramsSelector,
  userSelector,
} from "../../services/selectors/user.selectors";
import {
  useGetAllOpenTreatmentPlansForUserMutation,
  useGetAllRelevantTherapistForUserQuery,
} from "../../services/api/user.api";
import { getPrintDate } from "../../utils/utils";
import Modal from "../modals/modal/Modal";
import AppoitmentProgramPopup from "../modals/appoitmentProgramPopup/appoitmentProgramPopup";
import { ITreatmentPlan } from "../../services/types/user.types";
import Loader from "../loader/loader";
import GeneralErrorPopup from "../modals/errorPopup/errorPopup";
import { IUser } from "../../types/types";
import Therapist from "../therapist/therapist";
import i18n from "../../i18n";

function MyTreatment() {
  const user = useAppSelector(userSelector);

  const allTreatmentPlans = useAppSelector(
    userAllAppointmentProgramsSelector
  )?.filter((plan) => plan.appointmentsProgram.statusId !== 0);
  //this must use the correct endpoint

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openErrorModal, setOpenErrorModal] = useState<boolean>(false);
  const [currentTreatmentPlan, setCurrentTreatmentPlan] =
    useState<ITreatmentPlan | null>(null);
  const [
    getAllAppointmentProgram,
    { isLoading: isAppointmentProgramsLoading },
  ] = useGetAllOpenTreatmentPlansForUserMutation();
  const {
    data: therapists,
    error,
    isLoading,
  } = useGetAllRelevantTherapistForUserQuery({ Type: 1, UsersGuid: user.guid });
  const [currentTherapist, setCurrentTherapist] = useState<IUser | undefined>(
    undefined
  );
  useEffect(() => {
    if (!allTreatmentPlans.length) {
      getAllAppointmentProgram({
        companyId: user.companyId,
        UsersGuid: user.guid,
        usersName: user.fullName,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
// console.log(therapists);
  useEffect(() => {
    if (error) setOpenErrorModal(true);
  }, [error]);

  // if(currentTherapist!=undefined){
  //   <article>
  //           <Therapist
  //             therapist={currentTherapist}
  //             onClose={() => { }}
  //             setShowCalendar={() => { }} />
  //         </article>
  // }
  if (isAppointmentProgramsLoading) return <Loader />;
  return (
    <>
      {currentTherapist ? (
        <Therapist
          therapist={currentTherapist}
          onClose={() => {
            setCurrentTherapist(undefined);
          }}
        />
      ) : (
        <section dir={i18n.dir()} className={myTreatmentStyles.myTreatment}>
          {openModal && currentTreatmentPlan && (
            <Modal onClose={() => setOpenModal(false)}>
              <AppoitmentProgramPopup
                treatmentPlan={currentTreatmentPlan}
                onClose={() => setOpenModal(false)}
              />
            </Modal>
          )}
          {allTreatmentPlans && allTreatmentPlans.length !== 0 ? (
            <>
              <p className={myTreatmentStyles.title}>{t('MY_TREATMENT_PLANS')}</p>
              <ul className={myTreatmentStyles.allTreatments}>
                {allTreatmentPlans.map((s, index) => (
                  <li
                    key={index}
                    className={`${myTreatmentStyles.treatment} hover`}
                    onClick={() => {
                      setOpenModal(true);
                      setCurrentTreatmentPlan(s);
                    }}
                  >
                    <div>
                      <p className={myTreatmentStyles.treatmentDate}>
                        {getPrintDate(
                          new Date(s.appointmentsProgram.createDate)
                        )}
                      </p>
                      <p className={myTreatmentStyles.treatmentComment}>
                        {s.appointmentsProgram.name}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <h2 className="text">{t('TREATMENT_PLANS_NOT_SET')}</h2>
          )}

          {therapists && therapists.length > 0 ? (
            <>
              <p className={myTreatmentStyles.title}>{t('MY_THERAPISTS')}</p>
              <ul className={myTreatmentStyles.allTreatments}>
                {isLoading && <Loader />}
                {therapists.map((tr, i) => (
                  <li
                    key={i}
                    className={`${myTreatmentStyles.treatment} ${
                      myTreatmentStyles.therapistLi
                    } hover`}
                    onClick={() => {
                      setCurrentTherapist(tr);
                    }}
                  >
                    <AppImage
                      src={tr.avatar}
                      alt={tr.name}
                      className={myTreatmentStyles.therapistImg}
                    />
                    <div>
                      <p className={myTreatmentStyles.nameTag}>
                        {tr.fullName}
                      </p>
                      <div className={myTreatmentStyles.midLine}>
                        <p className={`${myTreatmentStyles.role}`}>
                          {tr.roles?.name}
                        </p>
                        <span className={myTreatmentStyles.myTherapist}>
                          {t('MY_THERAPIST')}
                        </span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            therapists?.length === 0 && (
              <h2 className="text">{t('TREATMENTS_NOT_ADDED_YET')}</h2>
            )
          )}

          {openErrorModal && (
            <Modal
              onClose={() => {
                setOpenErrorModal(false);
              }}
            >
              <GeneralErrorPopup
                onClose={() => {
                  setOpenErrorModal(false);
                }}
              />
            </Modal>
          )}
        </section>
      )}
    </>
  );
}

export default MyTreatment;
